import React, { useEffect, useState } from 'react';
import Sidebar from '../Components/Sidebar';
import VideoCard from '../Components/VideoCard';
import Header from '../Components/Header';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import GlobalAlert from '../Components/GlobalAlert'
import VideoPlaceholder from '../Components/VideoPlaceholder';

export default function Home() {
  const [data, setData] = useState([]);


  function fecthData() {
    fetch('https://apiv2.mobileartsme.com/av_getcontent?apisource=1&phonenumber=96170932819&ispremium=true&language=en&country=LB')
      .then(response => response.json())
      .then(data => {
        setData(data.Content[0].Videos)
        sessionStorage.setItem('av_data', JSON.stringify(data.Content[0].Videos))
        console.log(data.Content[0].Videos)
      }
      );
  }

  useEffect(() => {
    const sessiondata = JSON.parse(sessionStorage.getItem('av_data'))
    if (sessiondata) {
      setData(sessiondata)
    } else {
      fecthData()
    }
  }, []);








  return (
    <div>
      <GlobalAlert />

      <Sidebar data={data} />


      <div className="mt-3 main-body">
        <div className='container'>
          <Header />


          <div data-aos='zoom-in' className='my-5' >

            <h1 className='bold pt-4' >Welcome to <br></br>
              <span className='spangreen' >Amazing Videos</span></h1>

            <p>Discover movie news, trailers, fresh daily content, <br></br> live streaming, and other videos in different languages</p>

            {/* <div className='pt-3 d-flex flex-row gap-2'>
              <button>Download our app</button>
            </div> */}

          </div>


          {/* {data.slice(0, 6).map((item, index) => (
            <div key={index} className='mt-5' >
              <h2 className='mb-4'>{item.Name}</h2>
              <Swiper
                spaceBetween={20}
                slidesPerView={4}
                autoplay={{
                  delay: 500,
                  disableOnInteraction: false, // Ensures autoplay continues after interaction
                }}
                breakpoints={{
                  320: { slidesPerView: 2 },
                  480: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                  1124: { slidesPerView: 5 },
                }}
              >

                {item.Content.slice(0, 10).map((video, videoIndex) => (
                  <SwiperSlide key={videoIndex}>
                    <VideoCard key={index} video={video} category={item} />
                  </SwiperSlide>
                ))}

              </Swiper>
            </div>
          ))} */}


          {data.length !== 0 ? (
            data.slice(0, 6).map((item, index) => (
              <div key={index} className="mt-5">
                <h2 className="mb-4">{item.Name}</h2>
                <Swiper
                  spaceBetween={20}
                  slidesPerView={4}
                  autoplay={{
                    delay: 500,
                    disableOnInteraction: false, // Ensures autoplay continues after interaction
                  }}
                  breakpoints={{
                    320: { slidesPerView: 2 },
                    480: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 },
                    1124: { slidesPerView: 5 },
                  }}
                >
                  {item.Content.slice(0, 10).map((video, videoIndex) => (
                    <SwiperSlide key={videoIndex}>
                      <VideoCard key={videoIndex} video={video} category={item} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ))
          ) : (
            <div>
              <p className="placeholder-glow" style={{width:'200px'}}>
                <span className="placeholder col-12 span-placeholder"></span>
              </p>
              <Swiper
                spaceBetween={20}
                slidesPerView={4}
                autoplay={{
                  delay: 500,
                  disableOnInteraction: false, // Ensures autoplay continues after interaction
                }}
                breakpoints={{
                  320: { slidesPerView: 2 },
                  480: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  1024: { slidesPerView: 4 },
                  1124: { slidesPerView: 5 },
                }}
              >
                {[...Array(10)].map((_, i) => (
                   <SwiperSlide key={i}>
                    <VideoPlaceholder />
                    </SwiperSlide>
                  
                ))}


              </Swiper>

            </div>
          )}




        </div>
      </div>

    </div>
  );
}
